/**
 * Created by zzy on 2019/8/5.
 */
import AlarmCenter from './AlarmCenter.vue'
export default AlarmCenter



// WEBPACK FOOTER //
// ./src/views/home/alarmCenter/index.js